import React from 'react';

type ButtonVariant = 'primary' | 'success' | 'danger' | 'secondary' | 'info' | 'warning';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps {
  children: React.ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'sm',
  onClick,
  className = '',
  disabled = false,
  type = 'button'
}) => {
  const baseClasses =
    'font-medium rounded-lg transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2';

  const sizeClasses: Record<ButtonSize, string> = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-2.5 text-lg'
  };

 const variantClasses: Record<ButtonVariant, string> = {
  primary: 
    'bg-[#184A84] text-white hover:bg-[#0f3a6a] active:bg-[#0a2845] active:scale-[0.98] focus:ring-4 focus:ring-[#184A84]/30 focus:outline-none shadow-sm hover:shadow-md transition-all duration-200 font-medium',
  
  success: 
    'bg-emerald-500 text-white hover:bg-emerald-600 active:bg-emerald-700 active:scale-[0.98] focus:ring-4 focus:ring-emerald-500/30 focus:outline-none shadow-sm hover:shadow-md transition-all duration-200 font-medium',
  
  danger: 
    'bg-rose-500 text-white hover:bg-rose-600 active:bg-rose-700 active:scale-[0.98] focus:ring-4 focus:ring-rose-500/30 focus:outline-none shadow-sm hover:shadow-md transition-all duration-200 font-medium',
  
  secondary: 
    'bg-[#009A85] text-white hover:bg-[#008170] active:bg-[#00675a] active:scale-[0.98] focus:ring-4 focus:ring-[#009A85]/30 focus:outline-none shadow-sm hover:shadow-md transition-all duration-200 font-medium',
  
  info: 
    'bg-sky-500 text-white hover:bg-sky-600 active:bg-sky-700 active:scale-[0.98] focus:ring-4 focus:ring-sky-500/30 focus:outline-none shadow-sm hover:shadow-md transition-all duration-200 font-medium',
  
  warning: 
    'bg-amber-500 text-white hover:bg-amber-600 active:bg-amber-700 active:scale-[0.98] focus:ring-4 focus:ring-amber-500/30 focus:outline-none shadow-sm hover:shadow-md transition-all duration-200 font-medium'
};


  const disabledClasses = 'disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${disabledClasses} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
